import React, { useState, useEffect } from 'react'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import { DEFAULT_ERR_MSG, ERR_MSG_404_PROJECT_ID } from '../../../constants/msgText'
import MainProjectInfo from '../../../widgets/projectBasedItemsWidget/MainProjectInfo'
import ProjectNameNewWidget from '../../../widgets/projectProposal/project/ProjectNameNewWidget'
import { SUB_PROJECT_ID, TEMP_FORM_ID } from '../../../constants/constants'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { getSubProjectName } from '../../../redux/actions/subProjectProposal'
import ContentHeaderWidget from '../../../components/ContentHeader/ContentHeaderWidget'
import { getSettingFormProjectNamePreView } from '../../../redux/actions/subProjectFormSetting'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { getSubProjectPDPA, saveSubProjectPDPA } from '../../../redux/actions/projectOverview'
import { setAlertMessage } from '../../../utils/messageUtil'
import { Button, Checkbox, Modal } from 'rsuite'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import pathname from '../../../constants/pathname'
import PDPANoticeModal from '../../../components/pdpa/PDPANoticeModal'

export default function SubProjectNameNew(props) {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()

  const [acceptPDPA, setAcceptPDPA] = useState()
  const [showPDPA, setShowPDPA] = useState(true)
  const [PDPASchema, setPDPASchema] = useState()

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)
  const formId = sessionGetItemStr(TEMP_FORM_ID)

  const history = useHistory()

  useEffect(() => {
    // setSchema(mockSchema)
    if (mode == 'preView' && formId) {
      handleGetSchemaPreView()
    } else if (subProjectId) {
      handleGetSchema()
      handleGetPDPA()
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      //let _schema = cloneDeep(mockSchema) //await getProjectName(proposalId)
      let _schema = await getSubProjectName(subProjectId)

      setSchema(_schema)
      setIsEditWidget({
        projectName: _schema.forms?.projectName?.id ? false : true,
      })

      setShowEditAll(!_schema.forms?.projectName?.disabled)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetSchemaPreView = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let _schema = await getSettingFormProjectNamePreView(formId)

      setSchema(_schema)
      setIsEditWidget({
        projectName: true,
      })

      setShowEditAll(false)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetPDPA = async () => {
    setIsLoading(true)
    try {
      const response = await getSubProjectPDPA(subProjectId)
      if (response?.forms?.pdpa) {
        setPDPASchema(response?.forms?.pdpa)
      }
    } catch (e) {
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
    }
    setIsLoading(false)
  }

  const onCancle = () => {
    history.push({
      pathname: `${pathname.subProject.subProjectDashboard}`,
    })
  }

  const handleSavePDPA = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await saveSubProjectPDPA(subProjectId)
      if (response) {
        setShowPDPA(false)
      }
    } catch (e) {
      // console.log('e', e)
      setAlertMessage(
        'error',
        `PDPA error : ${e?.response?.data?.errors?.message || DEFAULT_ERR_MSG}`
      )
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isNewSubProject mode={mode}>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isNewSubProject mode={mode}>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isNewSubProject mode={mode}>
          <ContentHeaderWidget header={schema.header} subHeader={schema.subHeader} />

          {/* <MainProjectInfo schema={schema?.info?.projectInfo} /> */}

          {showEditAll && (
            <>
              <BtnEditAll
                onClickEditAll={getIsEditAll(isEditWidget)}
                routing={schema.buttonRoute}
                setOnClickEditAll={(_isEdit) =>
                  setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)
                }
                editWidget={isEditWidget}
                forms={schema?.forms}
              />
            </>
          )}

          {schema?.forms?.projectName && (
            <ProjectNameNewWidget
              showCommandButton={!schema.forms.projectName.disabled}
              schema={schema.forms.projectName}
              isEdit={isEditWidget.projectName}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('projectName', _isEdit, setIsEditWidget)
              }
            />
          )}



      {PDPASchema &&
        (PDPASchema?.isDep6 ? (
          <PDPANoticeModal
            show={showPDPA}
            onHide={onCancle}
            shouldRenderPdpaContent={!isLoading}
            acceptPDPA={acceptPDPA}
            setAcceptPDPA={setAcceptPDPA}
            saveButton={
              <SaveButton
                icon="check"
                disabled={!acceptPDPA}
                children="ยืนยัน"
                onClick={() => {
                  handleSavePDPA()
                }}
              />
            }
            cancelButton={<CancelButton children="ยกเลิก" onClick={onCancle} />}
          />
        ):
            <Modal backdrop size={'sm'} show={showPDPA} onHide={onCancle}>
              <Modal.Header>
                <Modal.Title>
                  <p style={{ paddingTop: '0.5rem' }}>PDPA</p>
                </Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <div style={{ marginLeft: 5, marginRight: 5 }}>
                  {PDPASchema.message}
                  <Button
                    block
                    color="blue"
                    style={{ minWidth: 200, marginTop: 20 }}
                    appearance="primary"
                    disabled={isLoading}
                    onClick={() => {
                      if (PDPASchema.url) {
                        window.open(PDPASchema.url, '_blank')
                      } else {
                        notification.open('error', {
                          title: 'ไม่พบ URL อ่านรายละเอียด PDPA',
                          duration: 5000,
                        })
                      }
                    }}
                  >
                    {PDPASchema.readPdpa}
                  </Button>
                  <Checkbox
                    style={{ marginTop: 20 }}
                    checked={acceptPDPA}
                    onChange={(_, check) => {
                      setAcceptPDPA(check)
                    }}
                  >
                    {PDPASchema.checkbox}
                  </Checkbox>
                </div>
              </Modal.Body>

              <Modal.Footer>
                <SaveButton
                  disabled={!acceptPDPA}
                  children="บันทึก"
                  onClick={() => {
                    handleSavePDPA()
                  }}
                />
                <CancelButton children="ยกเลิก" onClick={onCancle} />
              </Modal.Footer>
            </Modal>
          )
        }
      
        </SidebarProposal>
      )}
    </>
  )
}
